import Vue from 'vue';
//helper app
import './Components/Helpers/HelperComponent';
import UrlMixin from "./Mixins/UrlMixin";
Vue.mixin(UrlMixin)
/**
 * all component of GUD
 */
Vue.component('personal-information', require('./Components/Views/Auth/PersonalInformation').default);
Vue.component('password-change', require('./Components/Views/Auth/PasswordChange').default);
Vue.component('login', require('./Components/Views/Auth/Login').default);
Vue.component('password-reset', require('./Components/Views/Auth/PasswordReset').default);
Vue.component('reset-password', require('./Components/Views/Auth/ResetPassword').default);
Vue.component('registration', require('./Components/Views/Auth/Registration').default);
Vue.component('my-profile', require('./Components/Views/Auth/Profile').default);

// Settings
Vue.component('app-setting', require('./Components/Views/Settings/Index').default);
Vue.component('general-setting', require('./Components/Views/Settings/GeneralSetting').default);
Vue.component('email-setting', require('./Components/Views/Settings/EmailSetting').default);
Vue.component('sms-setting', require('./Components/Views/Settings/SmsSetting').default);
Vue.component('google-re-captcha-setting', require('./Components/Views/Settings/GoogleRecaptchaSetting').default);
Vue.component('notification-settings', require('./Components/Views/Settings/Notification/Settings/Index').default);
Vue.component('database-template', require('./Components/Views/Settings/Notification/Template/DatabaseTemplate').default);
Vue.component('mail-template', require('./Components/Views/Settings/Notification/Template/MailTemplate').default);

// User and Roles
Vue.component('user-roles', require('./Components/Views/UserRoles/Index').default);
Vue.component('group-of-users', require('./Components/Views/UserRoles/Roles/GroupOfUsers').default);

// Layouts
Vue.component('app-top-bar', require('./Components/Views/Layouts/Nabar').default);
Vue.component('app-sidebar', require('./Components/Views/Layouts/Sidebar').default);

// notifications
Vue.component('all-notification', require('./Components/Views/Auth/Notification').default);

Vue.component('app-products', require('./Components/Views/Product/Products').default);
Vue.component('app-product', require('./Components/Views/Product/Product').default);
Vue.component('app-product-create-edit', require('./Components/Views/Product/ProductCreateEdit').default)
Vue.component('app-categories', require('./Components/Views/Product/Categories').default);
Vue.component('app-category-media', require('./Components/Views/Product/CategoryMedia').default);
Vue.component('app-sub-categories', require('./Components/Views/Product/SubCategories').default);
Vue.component('app-category-create-edit', require('./Components/Views/Product/CategoryCreateEdit').default);
Vue.component('app-brands', require('./Components/Views/Product/Brands').default);
Vue.component('app-brand-create-edit', require('./Components/Views/Product/BrandCreateEdit').default)
Vue.component('app-thanas', require('./Components/Views/Support/Thanas').default)
Vue.component('app-thana-create-edit', require('./Components/Views/Support/Http/ThanasCreateEdit').default)
Vue.component('app-contact-us', require('./Components/Views/Support/ContactUs').default);
Vue.component('app-faqs', require('./Components/Views/Support/Faqs').default);
Vue.component('app-faq-create-edit', require('./Components/Views/Support/Http/FaqCreateEdit').default);
Vue.component('app-how-to-order', require('./Components/Views/Support/HowToOrder').default);
Vue.component('app-supports', require('./Components/Views/Support/Support').default);
Vue.component('app-banners', require('./Components/Views/Support/Banners').default);
Vue.component('app-banner-create-edit', require('./Components/Views/Support/Http/BannerCreateEdit').default);
Vue.component('app-earners', require('./Components/Views/Support/Earners').default);
Vue.component('app-earner-create-edit', require('./Components/Views/Support/Http/EarnerCreateEdit').default);
Vue.component('app-orders', require('./Components/Views/Order/Orders').default);
Vue.component('app-expandable-order-products', require('./Components/Views/Order/ExpandableOrderProducts').default);
Vue.component('app-product-media', require('./Components/Views/Order/ProductMedia').default);
Vue.component('app-expandable-order-user', require('./Components/Views/Order/ExpandableOrderUser').default);
Vue.component('app-expandable-order-details', require('./Components/Views/Order/ExpandableOrderDetails').default);
Vue.component('app-expandable-order-status', require('./Components/Views/Order/ExpandableOrderStatus').default);
Vue.component('app-order-status-change-modal', require('./Components/Views/Order/OrderStatusChangeModal').default);
Vue.component('app-order-reject-order', require('./Components/Views/Order/OrderRejectModal').default);